import React, { useState, useEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import rrulePlugin from '@fullcalendar/rrule';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { useSelector, useDispatch } from "react-redux";

import {
  createTask,
  fetchAllTask,
  fetchtaskByDate,
  updatetask,
  deletetask,
  getTaskById,
  getBirthdayByDate,
  getTaskByEmployeeId,
  createGoogleEvent,
  checkGoogleConnection,
  deleteGoogleEvent,
} from "../../core/data/redux/calendar/calendarAction";
import { AppDispatch } from "../../core/data/redux/store";
import { formatDate } from "../../core/utils/FormatData";
import Enum from "../../core/common/Enum/enum";

import Select from "react-select";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { fetchAllHolidays, fetchHolidayById } from "../../core/data/redux/holiday/holidayAction";
import {
  gettraininglistById,
  gettraininglistemployeeWise,
} from "../../core/data/redux/training/trainingAction";
import { getEmployeeByUserId } from "../../core/data/redux/employee/employeeAction";
import { stringify } from "querystring";
import { getEmployees } from "../../core/data/redux/employee/employeeAction";
import { DatePicker, message } from "antd";
import Confetti from 'react-confetti';
import { fetchEmployeesWithBirthdayToday } from "../../core/data/redux/dashboards/admindashboard/adminDashboardActions";
import { filterByStatus } from "../../core/utils/filterActiveData";
import { Modal, Descriptions, Tag } from "antd"
import dayjs from "dayjs";
interface Event {
  id: string;
  title: string;
  date: string;
}


type CalendarProps = {
  showForms: boolean;
  setShowForms: React.Dispatch<React.SetStateAction<boolean>>;
};

const Calendar: React.FC<CalendarProps> = ({ showForms, setShowForms }) => {
  const dispatch = useDispatch<AppDispatch>();
  const [modalType, setModalType] = useState<"edit" | "create" | "">("");
  const { employeeTasks, loadingStates } = useSelector((state: any) => state.calendar);
  const isLoading = modalType === "edit" ? loadingStates.update : loadingStates.create;
  const { birthdayEmployees } = useSelector((state: any) => state.dashboard.adminDashboard);
  const { training } = useSelector((state: any) => state.training);
  const [selectedDate, setSelectedDate] = useState<any>(null);
  const { holidays } = useSelector((state: any) => state.holiday);
  const [events, setEvents] = useState<any[]>([]);
  const { employees } = useSelector((state: any) => state.employee);
  const { user } = useSelector((state: any) => state.auth);
  const [showForm, setShowForm] = useState(false);
  const [clearFrom, setClearFrom] = useState(false);
  const [taskBydate, settaskBydate] = useState<any>();
  const [isEditing, setisEditing] = useState<any>(false);
  const [selectedId, setselectedId] = useState<any>(null);
  const [errors, setErrors] = useState<any>({});
  const [birthday, setbirthday] = useState<any>([]);
  const [isBirthdayModalOpen, setIsBirthdayModalOpen] = useState(false);
  const activeEmployees = filterByStatus(employees, 'active', 'employee_status');
  const [holidayFormData, setHolidayFormData] = useState<any>({});
  const [showHolidayModal, setShowHolidayModal] = useState(false);
  const { meetingLink } = useSelector((state: any) => state.calendar);
  const [loggedInEmployeeId, setLoggedInEmployeeId] = useState(null);
  const [isAddMode, setIsAddMode] = useState(false);
  const calendarRef = React.useRef<FullCalendar | null>(null);
  const [selectedMonth, setSelectedMonth] = useState<number>(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [showMiniCal, setShowMiniCal] = useState(false);
  const [miniCalDate, setMiniCalDate] = useState("");
  const [isGoogleConnected, setIsGoogleConnected] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState<any>(null);

  const handleJumpToMonth = () => {
    const date = new Date(selectedYear, selectedMonth, 1);
    calendarRef.current?.getApi().gotoDate(date);
  };

  const handleMiniCalSelect = (dateStr: any) => {
    const date = new Date(dateStr);
    calendarRef.current?.getApi().gotoDate(date);
    setShowMiniCal(false);
  };

  const showBirthdayModal = () => {
    setIsBirthdayModalOpen(true);
  };

  const handleBirthdayModalClose = () => {
    setIsBirthdayModalOpen(false);
  };

  useEffect(() => {
    setShowForm(showForms);
  }, [showForms]);

  useEffect(() => {
    if (showForms) {
      setisEditing(false);
      setIsAddMode(true);

      const now = new Date().toISOString().slice(0, 16);

      setFormData({
        Name: "",
        description: "",
        fromDate: now,
        toDate: now,
        repeat: "Does Not Repeat",
        snoozeTime: "None",
        meetingSchedule: "",
        MeetLink: "",
        attendees: [],
        mode: "",
        trainertype: "",
        AllDay: false,
        meetingPlatform: "",
        CreatedBy: loggedInEmployeeId
      });

    }
    setShowForm(showForms);
  }, [showForms]);


  // useEffect(() => {
  //   if (meetingLink) {
  //     setFormData((prev) => ({ ...prev, MeetLink: meetingLink }));
  //   }
  // }, [meetingLink]);


  const [formData, setFormData] = useState<{
    Name: string;
    description: string;
    fromDate: any;
    toDate: string;
    repeat: string;
    snoozeTime: string;
    meetingSchedule: string;
    MeetLink: any | string;
    attendees: { id: any | string; email: any }[]
    mode: string;
    trainertype: string;
    AllDay: Boolean;
    meetingPlatform: any;
    CreatedBy: any
  }>({
    Name: "",
    description: "",
    fromDate: selectedDate,
    toDate: "",
    repeat: "Does Not Repeat",
    snoozeTime: "None",
    meetingSchedule: "",
    MeetLink: "",
    attendees: [],
    mode: "",
    trainertype: "",
    AllDay: false,
    meetingPlatform: "",
    CreatedBy: loggedInEmployeeId
  });

  const [showModal, setShowModal] = useState(false);
  const [newEvent, setNewEvent] = useState<Partial<Event>>({
    title: "",
    date: selectedDate || "",
  });
  const [eventDetails, setEventDetails] = useState<Partial<Event> | null>(null);
  const getCurrentDate = () => new Date().toISOString().split("T")[0];
  const [trainingById, settrainingById] = useState<any>(null);

  const formattedEmployees = activeEmployees.map((emp: any) => ({
    value: emp.EmployeeID,
    label: emp.Name,
    email: emp.email
  }));

  // const test = activeEmployees?.map((a: any) => ({ email: a.email || a.value || a }));

  // const attendeesForGoogle = activeEmployees.map((a: any) => ({
  //   email: a.email
  // }));
  // console.log(attendeesForGoogle, 'emailgoogle')

  useEffect(() => {
    dispatch(fetchEmployeesWithBirthdayToday())
    dispatch(getEmployees());
    setSelectedDate(getCurrentDate());
    dispatch(fetchAllHolidays());
    const Id = `${user.UserId}`;
    dispatch(getEmployeeByUserId({ userId: Id })).then((res) => {
      const employeeId = res?.payload?.data?.employeeId;
      setLoggedInEmployeeId(employeeId);
      setTimeout(() => {
        dispatch(gettraininglistemployeeWise({ id: employeeId })).then(
          (res) => {
            settrainingById(res?.payload?.data);
          }
        );
        dispatch(getTaskByEmployeeId(employeeId))
      }, 1000);
    });

    function getTodayMonthDay() {
      const today = new Date();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${month}-${day}`;
    }

    const todayMMDD = getTodayMonthDay();
    dispatch(getBirthdayByDate(todayMMDD)).then((res) => {
      setbirthday(res.payload.data);
    });
  }, [dispatch]);


  const handleDateClick = (arg: { dateStr: string }) => {
    const clickedDate = arg.dateStr;
    setSelectedDate(clickedDate);
    setFormData({
      Name: "",
      description: "",
      fromDate: "",
      toDate: "",
      repeat: "Does Not Repeat",
      snoozeTime: "None",
      meetingSchedule: "",
      MeetLink: "",
      attendees: [],
      mode: "",
      trainertype: "",
      AllDay: false,
      meetingPlatform: "",
      CreatedBy: loggedInEmployeeId
    });
    // setShowForm(true);
    // setShowModal(true);

    const filteredEvents = events.filter((event) => {
      const start = event.start || event.date || event._instance?.range?.start;
      if (!start) return false;

      const eventDate = new Date(start).toISOString().split("T")[0];
      return eventDate === clickedDate;
    });

    console.log(filteredEvents, 'filteredEvent')
    settaskBydate(filteredEvents);
  };

  useEffect(() => {
    setSelectedDate(new Date().toISOString().split("T")[0]);
  }, []);

  useEffect(() => {
    if (!user?.UserId) return;
    dispatch(checkGoogleConnection({
      userId: user.UserId,
      dbName: subscriptionData?.database_name,
      companyCode: user?.company_code
    })).then((res: any) => {

      const status =
        res?.payload?.data?.isConnected ??
        res?.payload?.isConnected ??
        false;
      setIsGoogleConnected(status);
    });

  }, [user?.UserId, subscriptionData?.database_name]);

  useEffect(() => {
    dispatch(fetchAllTask());
  }, []);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAttendeesChange = (selectedOptions: any) => {
    setFormData((prev) => ({
      ...prev,
      attendees: selectedOptions
        ? selectedOptions.map((opt: any) => ({
          id: opt.value,
          email: opt.email || "",
        }))
        : [],
    }));
  };

  const trainerTypeOptions = [
    { value: "internal", label: "Internal" },
    { value: "external", label: "External" },
  ];
  const [showConfetti, setShowConfetti] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (showConfetti) {
      timer = setTimeout(() => {
        setShowConfetti(false);
      }, 2000);
    }
    return () => clearTimeout(timer);
  }, [showConfetti]);

  function CurrentDate(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const day = today.getDate().toString().padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  const aajdate = CurrentDate();

  useEffect(() => {
    dispatch(fetchtaskByDate(aajdate)).then((res) => {
      settaskBydate(res.payload.data);
    });
  }, [dispatch]);

  const validateForm = () => {
    let formIsValid = true;

    let newErrors: any = {
      Name: "",
      description: "",
      fromDate: "",
      toDate: "",
      repeat: "",
      snoozeTime: "",
      meetingSchedule: "",
      attendees: "",
      mode: "",
      trainertype: "",
    };

    if (!formData.Name.trim()) {
      formIsValid = false;
      newErrors.Name = "Name is required.";
    }


    if (!formData.fromDate) {
      formIsValid = false;
      newErrors.fromDate = "Start Date is required.";
    }

    if (!formData.toDate) {
      formIsValid = false;
      newErrors.toDate = "End Date is required.";
    }

    if (
      formData.fromDate &&
      formData.toDate &&
      new Date(formData.fromDate) > new Date(formData.toDate)
    ) {
      formIsValid = false;
      newErrors.toDate = "To date cannot be earlier than from date.";
    }

    if (!Array.isArray(formData.attendees) || formData.attendees?.length === 0) {
      formIsValid = false;
      newErrors.attendees = "Please select at least one attendee.";
    }

    if (!formData.repeat.trim()) {
      formIsValid = false;
      newErrors.repeat = "Please select a repeat option.";
    }

    if (!formData.snoozeTime.trim()) {
      formIsValid = false;
      newErrors.snoozeTime = "Please select a snooze time.";
    }

    if (!formData.meetingSchedule.trim()) {
      formIsValid = false;
      newErrors.meetingSchedule = "location/URL is required.";
    }

    if (!formData.mode.trim()) {
      formIsValid = false;
      newErrors.mode = "Please select a mode.";
    }

    if (!formData.trainertype.trim()) {
      formIsValid = false;
      newErrors.trainertype = "Please select a Event type.";
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!validateForm()) return;

    let meetLink = "";
    let eventId = null;

    if (formData.meetingPlatform === "Meet") {
      const googleResp = await dispatch(createGoogleEvent({
        userId: user.UserId,
        summary: formData.Name,
        start: formData.fromDate,
        end: formData.toDate,
        attendees: formData.attendees.map(a => ({ email: a.email }))
      }));

      meetLink = googleResp?.payload?.data?.meetLink || "";
      eventId = googleResp?.payload?.data?.eventId || null;
    }

    const payload = {
      ...formData,
      MeetLink: meetLink,
      event_id: eventId,
      CreatedBy: loggedInEmployeeId ?? "",
      attendees: formData.attendees.map((a: any) => a.id),
    };


    if (isEditing) {
      dispatch(updatetask({ id: selectedId, data: payload })).then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          message.success(res.payload.message);
          dispatch(fetchAllTask());
          setShowForms(false);
        } else {
          message.warning(res.payload.error);
        }
      });
    } else {
      dispatch(createTask(payload)).then((resp: any) => {
        if (resp.meta.requestStatus === "fulfilled") {
          message.success(resp.payload.message);
          setShowForm(false);
          setFormData({
            Name: "",
            description: "",
            fromDate: "",
            toDate: "",
            repeat: "Does Not Repeat",
            snoozeTime: "None",
            meetingSchedule: "",
            MeetLink: "",
            attendees: [],
            mode: "",
            trainertype: "",
            AllDay: false,
            meetingPlatform: "",
            CreatedBy: loggedInEmployeeId
          });
          dispatch(fetchAllTask());
          setShowForms(false);
        } else {
          message.warning(resp.payload.error);
        }
      });
    }
  };

  useEffect(() => {
    const listener = (event: MessageEvent) => {
      if (event.data === "google-connected") {
        setIsGoogleConnected(true);
        message.success("Google Calendar connected successfully!");
      }
    };

    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, []);

  useEffect(() => {

    const formattedTrainingByIdEvents = Array.isArray(trainingById)
      ? trainingById.map((training: any) => ({
        id: `training-by-id-${training.Id}`,
        title: training.Name || "Training",
        date: training.StartDate?.split("T")[0],
        description: training.Description,
        type: "training",
      }))
      : [];

    const holidayEvents = Array.isArray(holidays)
      ? holidays.map((item: any) => ({
        id: `holiday-${item.Id}`,
        title: item.Name || "Holiday",
        start: item.StartDate ? item.StartDate.split("T")[0] : null,
        end: item.EndDate ? item.EndDate.split("T")[0] : null,
        allDay: true,
        type: "holiday",
        description: item.Description,
        HolidayType: item.HolidayType,
        Status: item.Status
      }))
      : [];


    const birthdayEvents = Array.isArray(birthday)
      ? birthday.flatMap((item: any) => {
        const dobMD = item.dob_md; // "11-14"

        if (!dobMD || !dobMD.includes("-")) return [];

        const [month, day] = dobMD.split("-");

        return [
          {
            id: `birthday-${item.EmployeeID}`,
            title: `${item.FirstName}'s Birthday`,
            rrule: {
              freq: "yearly",
              bymonth: Number(month),
              bymonthday: Number(day),
              dtstart: `2010-${month}-${day}T00:00:00`,
            },
            type: "birthday",
            backgroundColor: "#E1BEE7",
            textColor: "#4A148C",
          },
        ];
      })
      : [];

    const formattedEvent = Array.isArray(employeeTasks)
      ? employeeTasks.map((item: any) => ({
        event_id: item.event_id,
        id: item.id,
        title: item.Name,
        start: item.StartDate,
        end: item.EndDate,
        repeat: item.Repeat,
        type: "event",
        description: item.Description,
        location: item.MeetingSchedule,
        mode: item.Mode,
        CreatedBy: item.CreatedBy,
      }))
      : [];
    console.log(employeeTasks, 'emp')

    const combinedEvents = [
      ...formattedEvent,
      ...holidayEvents,
      ...formattedTrainingByIdEvents,
      ...birthdayEvents,
    ];

    const convertedEvents = combinedEvents.map((ev: any) => {

      const repeat = ev.repeat || ev.extendedProps?.repeat;

      if (!repeat || repeat === "Does Not Repeat") {
        return ev;
      }

      const dtstart = ev.start;
      const until = ev.end;

      if (repeat === "Daily") {
        ev.rrule = { freq: "daily", dtstart, until };
      }
      if (repeat === "Weekly") {
        ev.rrule = { freq: "weekly", dtstart, until };
      }
      if (repeat === "Monthly") {
        ev.rrule = { freq: "monthly", dtstart, until };
      }

      ev.eventDataTransform = (raw: any) => ({
        ...raw,
        id: `${ev.id}-${raw.start}`,
        title: ev.title,
        date: raw.start,
        extendedProps: {
          ...raw.extendedProps,
          id: ev.id,
          type: ev.type,
          repeat: repeat,
        },
      });

      // delete ev.start;
      // delete ev.end;


      return ev;
    });


    setEvents(convertedEvents);
  }, [employeeTasks, holidays, trainingById, taskBydate]);

  const handleEventClick = async (info: any) => {
    const eventProps = info._def.extendedProps;
    const createdBy = Number(eventProps.CreatedBy);
    setIsAddMode(false);

    if (Number(loggedInEmployeeId) === createdBy) {
      setisEditing(true);
    } else {
      setisEditing(false);
    }

    if (
      info._def.extendedProps.type === "training" ||
      info._def.extendedProps.type === "birthday" ||
      info._def.extendedProps.type === "taskbydate"

    ) {
      message.warning("Cannot Update");
      return;
    }
    if (info._def.extendedProps.type === "holiday") {
      const idAfterDash = info._def.publicId.split("-").pop();
      const response = await dispatch(fetchHolidayById({ holidayId: idAfterDash }));

      if (response.meta.requestStatus === "fulfilled") {
        const holidayDataFromApi = response.payload?.data || {};
        const holidayData = {
          Name: holidayDataFromApi?.Name || "",
          description: holidayDataFromApi?.Description || "",
          fromDate: formatDate(holidayDataFromApi?.StartDate),
          toDate: formatDate(holidayDataFromApi?.EndDate),
          HolidayType: holidayDataFromApi?.HolidayType || "",
          Status: holidayDataFromApi?.Status || "active",
        };


        setHolidayFormData(holidayData);
        setShowHolidayModal(true);
        return;
      }
    }

    const eventData = info;
    setselectedId(Number(info?._def?.publicId));

    const taskId = Number(info?._def?.publicId);
    setselectedId(taskId);

    dispatch(getTaskById(taskId)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        const data = res.payload.data;

        const formatDateForInput = (isoDate: string) => {
          const date = new Date(isoDate);
          const offset = date.getTimezoneOffset();
          const localDate = new Date(date.getTime() - offset * 60 * 1000);
          return localDate.toISOString().slice(0, 16);
        };

        setFormData({
          Name: data.Name || "",
          description: data.Description || "",
          fromDate: data.StartDate ? formatDateForInput(data.StartDate) : "",
          toDate: data.EndDate ? formatDateForInput(data.EndDate) : "",
          repeat: data.Repeat,
          snoozeTime: data.SnoozeTime,
          meetingSchedule: data.MeetingSchedule || "",
          MeetLink: data.MeetLink || "",
          attendees: data.attendees || [],
          mode: data.Mode || "",
          trainertype: data.Trainertype || "",
          AllDay: data.AllDay || false,
          meetingPlatform: "",
          CreatedBy: loggedInEmployeeId
        });
      }
    });
    setShowForm(true);
    // setisEditing(true);
  };

  const dateCellContent = (arg: { date: Date; dayNumberText: string }) => {
    const dateStr = arg.date.toISOString().split("T")[0];
    const todayStr = new Date().toISOString().split("T")[0];

    const isToday = dateStr === todayStr;
    const hasEvent =
      Array.isArray(events) && events.some((event) => event.date === dateStr);

    let backgroundColor = "transparent";
    let textColor = "inherit";
    if (isToday) {
      backgroundColor = "#ffffff";
      textColor = "#6A1B9A";
    } else if (hasEvent) {
      backgroundColor = "#e0f7fa";
    }

    const isSelected = selectedDate === dateStr;

    return (
      <div
        style={{
          backgroundColor,
          borderRadius: "20px",
          padding: "5px",
          textAlign: "center",
          position: "relative",
        }}
        onClick={() => setSelectedDate(isSelected ? null : dateStr)}
      >
        {arg.dayNumberText}
      </div>
    );
  };
  // helping functions
  const getEmployeeNameById = (id: number | string) => {
    if (!employees) return "Unknown";
    const emp = employees.find((e: any) => Number(e.EmployeeID) === Number(id));
    return emp ? emp.Name : "Unknown";
  };

  const shortenTitle = (title: string) => {
    if (!title) return "";
    return title.length > 10 ? title.substring(0, 10) + "..." : title;
  };

  const fetchSubscriptionDetails = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_AUTH_SERVICE_SERVER_BASE_URL}/auth/subscription-detail`, {
        method: "GET",
        credentials: "include",
      });
      const result = await response.json();
      if (result.status === "success") {
        setSubscriptionData(result.data);
      } else {
        message.error("Failed to fetch subscription details");
      }
    } catch (error) {
      console.error("Error fetching subscription details:", error);
      message.error("Error loading subscription details");
    }
  };

  useEffect(() => {
    fetchSubscriptionDetails();
  }, [dispatch]);

  return (
    <div className="calendar-wrapper">
      <div className="calendar-sidebar"
        style={{
          width: "300px",
          minWidth: "180px",
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: "5px",
          overflowY: "auto",
        }}>
        <div className="mb-3">
          {isGoogleConnected ? (
            <button
              type="button"
              className="btn btn-success w-100"
              disabled
              style={{ cursor: "not-allowed" }}
            >
              Connected
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-danger w-100"
              onClick={() => {
                const BASE_URL = process.env.REACT_APP_EMPLOYEE_SERVICE_SERVER_BASE_URL;
                const oauthUrl = `${BASE_URL}/calendar/auth?userId=${user.UserId}&dbName=${subscriptionData?.database_name}&companyCode=${user.companyCode}`;

                const width = 500;
                const height = 600;
                const left = window.screenX + (window.outerWidth - width) / 2;
                const top = window.screenY + (window.outerHeight - height) / 2;
                const popup = window.open(oauthUrl, "GoogleCalendarAuth", `width=${width},height=${height},left=${left},top=${top}`);

                const timer = setInterval(() => {
                  if (popup && popup.closed) {
                    clearInterval(timer);
                    dispatch(checkGoogleConnection({
                      userId: user.UserId,
                      dbName: subscriptionData?.database_name,
                      companyCode: user.companyCode
                    })).then((res: any) => {
                      setIsGoogleConnected(res?.payload?.isConnected ?? false);
                    });
                  }
                }, 1000);
              }}
            >
              🔗 Connect Google Calendar
            </button>
          )}
        </div>
        <h3 style={{ fontSize: "14px", marginBottom: "15px" }}>
          Events on {formatDate(selectedDate)}
        </h3>
        <button
          onClick={showBirthdayModal}
          style={{
            backgroundColor: "goldenrod",
            color: "white",
            border: "none",
            borderRadius: "5px",
            padding: "6px 10px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            fontSize: "14px",
            fontWeight: "bold",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          Coming Birthday <span style={{ marginLeft: "6px" }}>▼</span>
        </button>
        <ul style={{ fontSize: "12px", listStyleType: "none", padding: 0 }}>
          {Array.isArray(taskBydate) && taskBydate?.length > 0 ? (
            taskBydate.map((event, idx) => {
              console.log(event, 'eventnew')
              let backgroundColor = "#1976D2";
              if (event.type === "event") backgroundColor = "#BBDEFB";
              else if (event.type === "holiday") backgroundColor = "#FFCDD2";
              else if (event.type === "training") backgroundColor = "#FFE0B2";
              else if (event.type === "taskbydate") backgroundColor = "#BBDEFB";

              let hoverColor = "#1976D2";
              if (event.type === "event") hoverColor = "#90CAF9";
              else if (event.type === "holiday") hoverColor = "#EF9A9A";
              else if (event.type === "training") hoverColor = "#FFCC80";
              else if (event.type === "taskbydate") hoverColor = "#BBDEFB";
              const eventType = event.type || event.extendedProps?.type;
              return (
                <li
                  key={`${event.id}-${idx}`}
                  onClick={() => setEventDetails(event)}
                  style={{
                    cursor: "pointer",
                    backgroundColor: backgroundColor,
                    color: "#000",
                    borderRadius: "5px",
                    marginBottom: "8px",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "8px 12px",
                    transition: "background 0.3s",
                    fontWeight: "bold",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = hoverColor;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = backgroundColor;
                  }}
                >
                  <span style={{ flex: 1, textAlign: "center" }}>
                    {event.title}
                  </span>

                  {eventType === "event" && Number(event.CreatedBy) === Number(loggedInEmployeeId) && (
                    <FontAwesomeIcon
                      icon={faTrash}
                      style={{
                        cursor: "pointer",
                        color: "#D32F2F",
                        fontSize: "16px",
                        fontWeight: "bold",
                        marginLeft: "12px",
                      }}
                      onClick={async (e) => {
                        e.stopPropagation();
                        const taskId = event.id || event.publicId || event._def?.publicId;
                        const googleEventId = event.event_id;

                        try {
                          if (googleEventId) {
                            await dispatch(deleteGoogleEvent({
                              userId: user.UserId,
                              eventId: googleEventId,
                              companyCode: user.companyCode,
                              dbName: subscriptionData?.database_name
                            }));
                          }

                          const res = await dispatch(deletetask(taskId));

                          if (res.meta.requestStatus === "fulfilled") {
                            message.success("Event deleted successfully!");
                            dispatch(fetchAllTask());
                          } else {
                            message.warning(res.payload.error);
                          }

                        } catch (err) {
                          message.error("Failed to delete event.");
                        }
                      }}
                    />
                  )}
                </li>
              );
            })
          ) : (
            <li style={{ textAlign: "center", fontWeight: "bold" }}>
              No events found
            </li>
          )}
        </ul>
      </div>

      {/* Calendar Box */}
      <div className="calendar-main">
        <div
          style={{
            display: "flex",
            gap: "10px",
            marginBottom: "10px",
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <select
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(Number(e.target.value))}
            style={{ padding: "6px", borderRadius: "5px", border: "1px solid #ccc" }}
          >
            {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((m, i) => (
              <option key={i} value={i}>{m}</option>
            ))}
          </select>

          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(Number(e.target.value))}
            style={{ padding: "6px", borderRadius: "5px", border: "1px solid #ccc" }}
          >
            {Array.from({ length: 40 }, (_, i) => 2010 + i).map((yr) => (
              <option key={yr} value={yr}>{yr}</option>
            ))}
          </select>

          <button
            onClick={handleJumpToMonth}
            className="calendar-top-controls"
            style={{
              backgroundColor: "#542EAC",
              color: "white",
              padding: "6px 12px",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            Jump📅
          </button>
        </div>

        <FullCalendar
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, rrulePlugin]}
          initialView="dayGridMonth"
          dateClick={handleDateClick}
          events={events}
          ref={calendarRef}
          height="500px"
          contentHeight="auto"
          headerToolbar={{
            left: "prev,next today",
            center: "title",
            right: "dayGridMonth,timeGridWeek,timeGridDay addEventButton",
          }}
          dayCellContent={dateCellContent}
          eventContent={(eventInfo) => {
            const eventType = eventInfo.event.extendedProps.type;

            let backgroundColor = "#1976D2";
            if (eventType === "event") backgroundColor = "#BBDEFB";
            else if (eventType === "holiday") backgroundColor = "#FFCDD2";
            else if (eventType === "training") backgroundColor = "#FFE0B2";
            else if (eventType === "birthday") backgroundColor = "#E1BEE7";
            const props = eventInfo.event.extendedProps;
            let tooltipText = "";

            if (eventType === "birthday" || eventType === "training" || eventType === "holiday") {
              tooltipText = eventInfo.event.title;
            } else {
              const creatorName = getEmployeeNameById(props.CreatedBy);
              tooltipText = creatorName
            }
            return (
              <div
                title={`Author : ${tooltipText}`}
                style={{
                  fontSize: "12px",
                  padding: "3px 5px",
                  borderRadius: "4px",
                  textAlign: "center",
                  color: "black",
                  backgroundColor,
                  width: "100%",
                  boxSizing: "border-box",
                  display: "block",
                  // border: "1px solid #ccc",
                }}
              >
                {shortenTitle(eventInfo.event.title)}
              </div>
            );
          }}
          eventClick={(info: any) => handleEventClick(info.event)}
        />
        {showMiniCal && (
          <div
            style={{
              position: "absolute",
              background: "white",
              padding: "15px",
              border: "1px solid #ccc",
              borderRadius: "10px",
              zIndex: 2000,
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            }}
          >
            <input
              type="date"
              value={miniCalDate}
              onChange={(e) => {
                setMiniCalDate(e.target.value);
                handleMiniCalSelect(e.target.value);
              }}
              style={{
                padding: "8px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "16px",
              }}
            />
          </div>
        )}

      </div>
      {showForm && (
        <div
          className="modal fade show d-block modal-backdrop-custom"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-md slide-in-right">
            <div className="modal-content">
              <div
                className="modal-header text-white"
                style={{ backgroundColor: "#542EAC" }}
              >
                <h5 className="modal-title">Event</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowForm(false);
                    setisEditing(false);
                    setShowForms(false);
                  }}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <div className="col-3">
                      <label className="form-label">
                        Name <span className="text-danger"> *</span>
                      </label>
                    </div>
                    <div className="col-9">
                      <input
                        type="text"
                        className="form-control"
                        name="Name"
                        value={formData.Name}
                        onChange={handleChange}
                      />
                      {errors.Name && (
                        <div style={{ color: "red" }}>{errors.Name}</div>
                      )}
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-3">
                      <label className="form-label">
                        Start Date <span className="text-danger"> *</span>
                      </label>
                    </div>
                    <div className="col-9">
                      <DatePicker
                        showTime={{
                          format: "HH:mm",
                          showNow: true,     // ✔ Shows "Now" button
                        }}
                        format="YYYY-MM-DD HH:mm"
                        value={formData.fromDate ? dayjs(formData.fromDate) : null}
                        onChange={(date, dateString) => {
                          setFormData(prev => ({
                            ...prev,
                            fromDate: dateString
                          }));
                        }}
                        style={{ width: "100%" }}
                      />
                      {errors.fromDate && (
                        <div style={{ color: "red" }}>{errors.fromDate}</div>
                      )}
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-3">
                      <label className="form-label">
                        End Date <span className="text-danger"> *</span>
                      </label>
                    </div>
                    <div className="col-9">
                      <DatePicker
                        showTime={{
                          format: "HH:mm",
                          showNow: true,     // ✔ Shows "Now" button
                        }}
                        format="YYYY-MM-DD HH:mm"
                        value={formData.toDate ? dayjs(formData.toDate) : null}
                        onChange={(date, dateString) => {
                          setFormData((prev: any) => ({
                            ...prev,
                            toDate: dateString
                          }));
                        }}
                      />
                      {errors.toDate && (
                        <div style={{ color: "red" }}>{errors.toDate}</div>
                      )}
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-3">
                      <label className="form-label">
                        Repeat <span className="text-danger"> *</span>
                      </label>
                    </div>
                    <div className="col-9">
                      <select
                        className="form-control"
                        name="repeat"
                        value={formData.repeat}
                        onChange={handleChange}
                      >
                        <option>Does Not Repeat</option>
                        <option>Daily</option>
                        <option>Weekly</option>
                        <option>Monthly</option>
                      </select>
                      {errors.repeat && (
                        <div style={{ color: "red" }}>{errors.repeat}</div>
                      )}
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-3">
                      <label className="form-label">
                        Snooze Time <span className="text-danger"> *</span>
                      </label>
                    </div>
                    <div className="col-9">
                      <select
                        className="form-control"
                        name="snoozeTime"
                        value={formData.snoozeTime}
                        onChange={handleChange}
                      >
                        <option>None</option>
                        <option>5 minutes</option>
                        <option>10 minutes</option>
                        <option>15 minutes</option>
                      </select>
                      {errors.snoozeTime && (
                        <div style={{ color: "red" }}>{errors.snoozeTime}</div>
                      )}
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-3">
                      <label className="form-label">
                        Mode <span className="text-danger"> *</span>
                      </label>
                    </div>
                    <div className="col-9">
                      <select
                        className="form-control"
                        name="mode"
                        value={formData.mode}
                        onChange={handleChange}
                      >
                        <option value="">Select Mode</option>
                        {Object.entries(Enum.TrainingMode).map(
                          ([key, value]) => (
                            <option key={key} value={value}>
                              {value}
                            </option>
                          )
                        )}
                      </select>
                      {errors.mode && (
                        <div style={{ color: "red" }}>{errors.mode}</div>
                      )}
                    </div>
                  </div>

                  {formData.mode === "online" && (
                    <div className="row mb-3">
                      <div className="col-3">
                        <label className="form-label">Meeting Platform</label>
                      </div>
                      <div className="col-9 d-flex align-items-center gap-2">
                        <select
                          className="form-control"
                          name="meetingPlatform"
                          onChange={handleChange}
                        >
                          <option value="">Select Platform</option>
                          <option value="Meet">Google Meet</option>
                          {/* <option value="Teams">Microsoft Teams</option> */}
                        </select>

                        {/* {formData.meetingPlatform && (
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={handleCreateLink}
                            disabled={loadingStates.meetLink}
                          >
                            {loadingStates.meetLink ? "Creating..." : "Create Link"}
                          </button>
                        )} */}
                      </div>

                      {formData.MeetLink && (
                        <div className="col-9 offset-3 mt-2">
                          <a
                            href={formData.MeetLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ fontWeight: "bold", color: "#0066cc", textDecoration: "underline" }}
                          >
                            {formData.MeetLink}
                          </a>
                        </div>
                      )}
                    </div>
                  )}
                  <div className="row mb-3">
                    <div className="col-3">
                      <label className="form-label">
                        Event Type <span className="text-danger"> *</span>
                      </label>
                    </div>
                    <div className="col-9">
                      <select
                        className="form-control"
                        name="trainertype"
                        value={formData.trainertype}
                        onChange={handleChange}
                      >
                        <option value="">Select Type</option>
                        {trainerTypeOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                      {errors.trainertype && (
                        <div style={{ color: "red" }}>{errors.trainertype}</div>
                      )}
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-3">
                      <label className="form-label">
                        Location/URL <span className="text-danger"> *</span>
                      </label>
                    </div>
                    <div className="col-9">
                      <input
                        type="text"
                        className="form-control"
                        name="meetingSchedule"
                        value={formData.meetingSchedule}
                        onChange={handleChange}
                      />
                      {errors.meetingSchedule && (
                        <div style={{ color: "red" }}>
                          {errors.meetingSchedule}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-3">
                      <label className="form-label">
                        Attendees <span className="text-danger"> *</span>
                      </label>
                    </div>
                    <div className="col-9">
                      <Select
                        isMulti
                        options={[...formattedEmployees].sort((a, b) => a.label.localeCompare(b.label))}
                        value={formattedEmployees.filter((option: any) =>
                          formData.attendees.some((att: any) => att.id === option.value)
                        )}
                        onChange={handleAttendeesChange}
                        placeholder="Select attendees..."
                        className="basic-multi-select"
                        classNamePrefix="select"
                      />
                      {errors.attendees && (
                        <div style={{ color: "red" }}>{errors.attendees}</div>
                      )}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-3"></div>
                    <div className="col-9">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          justifyContent: "flex-start",
                        }}
                      >
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="allDay"
                          name="AllDay"
                          checked={Boolean(formData.AllDay)}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              AllDay: Boolean(e.target.checked),
                            }))
                          }
                          style={{
                            border: "2px solid black",
                            width: "18px",
                            height: "18px",
                            borderRadius: "4px",
                          }}
                        />
                        <label className="form-check-label" htmlFor="allDay">
                          All day
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-3">
                      <label className="form-label">
                        Description
                      </label>
                    </div>
                    <div className="col-9">
                      <textarea
                        className="form-control"
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                      />
                      {errors.description && (
                        <div style={{ color: "red" }}>{errors.description}</div>
                      )}
                    </div>
                  </div>
                  <div className="modal-footer">
                    {(isAddMode || isEditing) && (
                      <button
                        type="submit"
                        className="btn me-2"
                        style={{ backgroundColor: "#542EAC", color: "white", border: "none", }}
                        disabled={isLoading}
                      > {isLoading && <span className="spinner-border spinner-border-sm me-2" />}
                        Save
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn"
                      style={{
                        backgroundColor: "white",
                        color: "black",
                        border: "1px solid #542EAC",
                      }}
                      onClick={() => {
                        setShowForm(false);
                        setErrors({});
                        setFormData({
                          Name: "",
                          description: "",
                          fromDate: "",
                          toDate: "",
                          repeat: "Does Not Repeat",
                          snoozeTime: "None",
                          meetingSchedule: "",
                          MeetLink: "",
                          attendees: [],
                          mode: "",
                          trainertype: "",
                          AllDay: false,
                          meetingPlatform: "",
                          CreatedBy: loggedInEmployeeId
                        });
                        setShowForms(false);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}


      <Modal
        title="Birthdays"
        open={isBirthdayModalOpen}
        onCancel={handleBirthdayModalClose}
        footer={null}
      // centered
      >
        {!birthday && birthday?.length === 0 ? (
          <p>No birthdays found for this date.</p>
        ) : (
          <ul>
            {birthday && birthday.map((emp: any) => (
              <li key={emp.EmployeeID}>
                <strong>{emp.Name}</strong> — {formatDate(emp.DateOfBirth)}
              </li>
            ))}
          </ul>
        )}

        {showConfetti && (
          <Confetti
            width={window.innerWidth}
            height={window.innerHeight}
            recycle={false}
          />
        )}
      </Modal>


      <Modal
        title="Holiday Details"
        open={showHolidayModal} // AntD v5 uses 'open' instead of 'visible'
        onCancel={() => setShowHolidayModal(false)}
        footer={null}
        width={600}
        centered
      >
        <Descriptions
          column={1}
          bordered
          size="middle"
          labelStyle={{ fontWeight: "bold", width: 120 }}
          contentStyle={{ color: "#555" }}
        >
          <Descriptions.Item label="Name">{holidayFormData.Name || "-"}</Descriptions.Item>
          <Descriptions.Item label="Description">{holidayFormData.description || "-"}</Descriptions.Item>
          <Descriptions.Item label="From">{holidayFormData.fromDate || "-"}</Descriptions.Item>
          <Descriptions.Item label="To">{holidayFormData.toDate || "-"}</Descriptions.Item>
          <Descriptions.Item label="Type">
            <Tag color="blue">{holidayFormData.HolidayType || "-"}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Status">
            <Tag color={holidayFormData.Status === "Active" ? "green" : "red"}>
              {holidayFormData.Status || "-"}
            </Tag>
          </Descriptions.Item>
        </Descriptions>
      </Modal>


      <style>
        {`
  .slide-in-right {
    position: fixed;
    top: 50px;
    right: 0;
    height: calc(100% - 50px);
    width: 600px;
    margin: 0;
    transform: translateX(100%);
    transition: transform 0.4s ease-in-out;
    z-index: 1050;
  }

  .modal.show .slide-in-right {
    transform: translateX(0);
  }

  .modal-backdrop-custom {
    background-color: rgba(0, 0, 0, 0.5);
  }

  .modal-dialog.modal-md {
    max-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .modal-content {
    max-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .modal-body {
    overflow-y: auto;
    flex-grow: 1;
    padding-bottom: 50px;
  }

  .fc-event {
  padding: 0 !important;
}

/* Mobile view start here */
.calendar-wrapper {
  display: flex;
  height: 100vh;
  gap: 10px;
}

/* LEFT PANEL */
.calendar-sidebar {
  width: 300px;
  min-width: 180px;
}

/* CALENDAR */
.calendar-main {
  flex-grow: 1;
  max-width: 800px;
}

/* 📱 MOBILE FIX */
@media (max-width: 768px) {
  .calendar-wrapper {
    flex-direction: column;
    height: auto;
  }

  .calendar-sidebar {
    width: 100%;
    order: 1;
  }

  .calendar-main {
    width: 100%;
    max-width: 100%;
    order: 0;
  }

  /* FullCalendar header fix */
  .fc-header-toolbar {
    flex-direction: column;
    gap: 6px;
  }

  .fc-toolbar-chunk {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

   /* Row 1: prev / today / next */
  .fc-header-toolbar .fc-toolbar-chunk:first-child {
    justify-content: space-between;
  }

  /* Row 2: January 2026 */
  .fc-header-toolbar .fc-toolbar-chunk:nth-child(2) {
    justify-content: center;
    font-weight: 600;
    font-size: 14px;
  }

  /* Row 3: Month / Week / Day */
  .fc-header-toolbar .fc-toolbar-chunk:last-child {
    justify-content: center;
    gap: 6px;
  }

  /* Mobile button size */
  .fc-button {
    padding: 4px 6px !important;
    font-size: 12px !important;
  }
}
@media (max-width: 768px) {

  /* Put custom controls + calendar toolbar in one row */
  .calendar-top-controls,
  .fc-header-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 6px;
  }

  /* Force toolbar into single line */
  .fc-header-toolbar {
    flex-direction: row !important;
  }

  /* Bold custom title look */
  .fc .fc-toolbar-title {
    display: block;
    width: 100%;
    text-align: center;
    font-weight: bold;
    font-size: 14px;
  }

  /* Month / Week / Day in one row */
  .fc-header-toolbar .fc-toolbar-chunk:last-child {
    display: flex;
    gap: 6px;
  }

  .fc-button {
    padding: 4px 6px !important;
    font-size: 12px !important;
  }
}

`}
      </style>
    </div>
  );
};

export default Calendar;
